/*
 * Copyright (C) 2009-2025 SonarSource Sàrl
 * All rights reserved
 * mailto:info AT sonarsource DOT com
 */

import { Layout, Link, LinkHighlight, MessageVariety, Text } from '@sonarsource/echoes-react';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useAppState } from '~sq-server-commons/context/app-state/withAppStateContext';
import { useCurrentUser } from '~sq-server-commons/context/current-user/CurrentUserContext';
import { useCurrentLicenseQuery } from '~sq-server-commons/queries/entitlements';
import { isLoggedIn } from '~sq-server-commons/types/users';

export function StartupLicenseCheckBanner() {
  const appState = useAppState();
  const { currentUser } = useCurrentUser();

  const canSetLicense = isLoggedIn(currentUser) && !!appState.canAdmin;

  const { data: license, isLoading } = useCurrentLicenseQuery({
    enabled: canSetLicense,
  });

  const [shouldShowBanner, setShouldShowBanner] = useState(false);

  useEffect(() => {
    if (canSetLicense && !isLoading && !license?.validEdition) {
      setShouldShowBanner(true);
    }
  }, [canSetLicense, isLoading, license]);

  return (
    shouldShowBanner && (
      <Layout.Banner variety={MessageVariety.Danger}>
        <FormattedMessage
          id="license.prompt.description"
          values={{
            title: (
              <Text as="strong" colorOverride="echoes-color-text-danger">
                <FormattedMessage id="license.prompt.title" />
              </Text>
            ),
            url: (
              <Link highlight={LinkHighlight.CurrentColor} to="/admin/license/app">
                <FormattedMessage id="license.prompt.link" />
              </Link>
            ),
          }}
        />
      </Layout.Banner>
    )
  );
}
